var _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 0C9.62588 0 0 9.62588 0 21.5C0 33.3741 9.62588 43 21.5 43C33.3741 43 43 33.3741 43 21.5H30.9062C30.9062 26.6949 26.6949 30.9062 21.5 30.9062C16.3051 30.9062 12.0938 26.6949 12.0938 21.5C12.0938 16.3051 16.3051 12.0938 21.5 12.0938V0Z",
    fill: "#FD9C2A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.1875,
    y: 10.75,
    width: 2.6875,
    height: 8.0625,
    fill: "#FD9C2A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2188,
    y: 6.04688,
    width: 2.6875,
    height: 12.7656,
    fill: "#FD9C2A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.25,
    y: 3.35938,
    width: 2.6875,
    height: 15.4531,
    fill: "#FD9C2A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2812,
    y: 7.39062,
    width: 2.6875,
    height: 11.4219,
    fill: "#FD9C2A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40.3125,
    y: 13.4375,
    width: 2.6875,
    height: 5.375,
    fill: "#FD9C2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRound);
export default __webpack_public_path__ + "static/media/logo-round.f23976c242be31377539d5c50f16a94d.svg";
export { ForwardRef as ReactComponent };